<template>
  <div class="iframe-wrapper">
    <iframe src="/landing/index.html" class="landing-iframe" />
  </div>
</template>

<style scoped>
.iframe-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0;
  padding: 0;
  border: none;
  overflow: hidden;
  z-index: 9999; /* если нужно поверх других элементов */
}

.landing-iframe {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
</style>
